import { FilterSelectionState } from '@/filters/selection/FilterSelectionState';
import { Degree } from '@/models/Degree';
import { injectable } from 'inversify';
import { IHandler } from './IHandler';
import { FilterOptions } from '@/filters/options/FilterOptions';
import { ISeoMetaDataInfo } from './ISeoMetaDataInfo';
import { SeoInfoBase } from '../SeoInfoBase';
import { SortingState } from '@/sorting/SortingState';

@injectable()
export abstract class SeoMetaDataHandler extends SeoInfoBase implements IHandler {
	public constructor(filterOptions: FilterOptions) {
		super(filterOptions);
	}

	protected nextHandler?: IHandler;

	public setNext(handler: SeoMetaDataHandler): SeoMetaDataHandler {
		this.nextHandler = handler;
		return handler;
	}

	public async handle(degree: Degree, filterSelectionState: FilterSelectionState, sortState: SortingState): Promise<ISeoMetaDataInfo> {
		return (await this.canHandle(sortState, filterSelectionState))
			? await this.selfHandle(degree, filterSelectionState)
			: await this.next(degree, filterSelectionState, sortState);
	}

	protected async next(degree: Degree, filterSelectionState: FilterSelectionState, sortState: SortingState): Promise<ISeoMetaDataInfo> {
		return this.nextHandler !== undefined
			? await this.nextHandler.handle(degree, filterSelectionState, sortState)
			: ({} as ISeoMetaDataInfo);
	}

	public abstract canHandle(sortState: SortingState, filterSelectionState: FilterSelectionState): Promise<boolean>;

	protected abstract selfHandle(
		degree: Degree,
		filterSelectionState?: FilterSelectionState,
		sortState?: SortingState
	): Promise<ISeoMetaDataInfo>;
}
